<!-- Responsibility: Implement player profile header behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<player-profile-header>
    <div class="pph-header" if={ props.model && props.model.isReady }>
        <div class="pph-portrait { props.portraitZoomed ? 'zoomed' : '' }"
             style="background-image:{ props.model.portraitUrl ? 'url('+props.model.portraitUrl+')' : 'none' }"
             role="button"
             tabindex="0"
             aria-label="Toggle portrait zoom"
             onclick={ props.onTogglePortraitZoom }
             onkeydown={ (e) => props.onActivateKey && props.onActivateKey(e, props.onTogglePortraitZoom) }>
            <span if={ !props.model.portraitUrl }>{ props.model.portraitInitials }</span>
        </div>
        <div class="pph-identity">
            <div class="pph-name-row">
                <h2 class="pph-name">{ props.model.titleName }</h2>
                <span class="pph-time">{ props.model.timeLabel }</span>
            </div>
            <p if={ props.model.player && props.model.player.name } class="pph-identity-desc">
                <span class="pph-identity-desc"> { props.model.sex }</span>&nbsp;
                <span>{ props.model.identity }</span>
            </p>
            <p class="pph-bio">{ props.model.bio }</p>
            <div class="pph-location">CURRENTLY AT: <span>{ props.model.currentRoomName.toUpperCase() }</span></div>
        </div>
        <button class="pph-close modal-close-hit" aria-label="Close profile modal" onclick={ props.onClose }>✕</button>
    </div>

    <style>
        .pph-header {
            padding: var(--space-lg);
            display: flex;
            gap: var(--space-lg);
            border-bottom: 1px solid var(--border);
            background: var(--bg);
            position: relative;
        }

        .pph-portrait {
            width: 7.5rem;
            height: 9.375rem;
            flex-shrink: 0;
            background-size: cover;
            background-position: center;
            background-color: #050812;
            border: 0.125rem solid var(--gold, var(--gold));
            border-radius: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: var(--space-lg);
            font-weight: bold;
            color: var(--gold);
            cursor: zoom-in;
            transition: transform 0.25s ease, z-index 0.25s ease, box-shadow 0.25s ease;
            position: relative;
            z-index: 2;
        }

        .pph-portrait.zoomed {
            cursor: zoom-out;
            transform: scale(2.2);
            transform-origin: top left;
            z-index: 4;
            box-shadow: 0 0.625rem 1.875rem rgba(0, 0, 0, 0.8);
        }

        .pph-identity {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: var(--space-sm);
        }

        .pph-name-row {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            gap: var(--space-md);
        }

        .pph-name {
            margin: 0;
            font-size: 1.8rem;
            color: var(--gold);
            letter-spacing: 0.1em;
            text-transform: uppercase;
        }

        .pph-time {
            font-size: var(--space-sm);
            color: var(--text-muted, var(--text-dim));
            font-weight: bold;
            letter-spacing: 0.15em;
        }

        .pph-identity-desc {
            margin: 0 0 var(--space-xs);
            font-size: var(--space-sm);
            color: var(--text-muted);
            letter-spacing: 0.03em;
            line-height: 1.4;
        }

        .pph-bio {
            margin: 0;
            font-family: var(--font-narrative, 'Lora', serif);
            font-size: var(--space-md);
            line-height: 1.6;
            opacity: 0.85;
            font-style: italic;
        }

        .pph-location {
            font-size: var(--space-sm);
            color: var(--text-dim, #334155);
            letter-spacing: 0.1em;
            font-weight: bold;
        }

        .pph-location span {
            color: var(--text-muted);
        }

        .pph-close {
            position: absolute;
            top: var(--space-md);
            right: 1.25rem;
            background: none;
            border: none;
            color: var(--text-dim);
            font-size: var(--space-lg);
            cursor: pointer;
            width: calc(var(--tap-target-min, 2.75rem) + 0.125rem);
            height: calc(var(--tap-target-min, 2.75rem) + 0.125rem);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: color 0.2s;
        }

        .pph-close:hover {
            color: var(--gold);
        }

        @media (max-width: 40.625rem) {
            .pph-header {
                flex-direction: column;
                align-items: center;
                text-align: center;
                gap: var(--space-md);
            }

            .pph-name-row {
                flex-direction: column;
                align-items: center;
                gap: var(--space-xs);
            }
        }
    </style>
</player-profile-header>
